import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ISetProjectControlledPermissionsParams {
  ids: string[];
  nestedProjectsPermissionsIncluded?: boolean;
}

export class SetProjectControlledPermissionsRequest
    extends Request<ISetProjectControlledPermissionsParams, IEmptyResult> {
  constructor(params: ISetProjectControlledPermissionsParams) {
    super('setProjectControlledPermissions', params);
  }
}
